var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"sky-span"},[_vm._v(_vm._s(_vm.data))])
}
var staticRenderFns = []

export { render, staticRenderFns }